import { Reports } from './pages/reports';

// Serviços
import { ExportPharma } from './pages/exportPharma';

// Propostas
import { ProposalsBySeller } from './pages/proposalsBySeller';
import { ProposalsForRenewal } from './pages/proposalsForRenewal';
import { ProposalsBySituation } from './pages/proposalsBySituation';
import { ProposalsCardPrinting } from './pages/proposalsCardPrinting';
import { ProposalsByOrganization } from './pages/proposalsByOrganization';
import { ProposalsByPlan } from './pages/proposalsByPlan';
import { ProposalsByCredentialsNT } from './pages/proposalsByCredentialsNT';
import { DeliveryTerm } from './pages/deliveryTerm';

// Financeiro
import { FinancialPayrollDiscount } from './pages/financialPayrollDiscount';
import { FinancialBillsToReceive } from './pages/financialBillsToReceive';
import { FinancialBillsToPay } from './pages/financialBillsToPay';
import { SellersCommission } from './pages/sellersCommission';
import { EnvelopePrint } from './pages/envelopePrint';

export const ReportsRoutes = [
  {
    path: '/relatorios',
    exact: true,
    component: Reports,
  },
  {
    path: '/relatorios/propostas-por-corretor',
    exact: true,
    component: ProposalsBySeller,
  },
  {
    path: '/relatorios/propostas-para-renovacao',
    exact: true,
    component: ProposalsForRenewal,
  },
  {
    path: '/relatorios/exportacao-farmacia',
    exact: true,
    component: ExportPharma,
  },
  {
    path: '/relatorios/propostas-por-situacao',
    exact: true,
    component: ProposalsBySituation,
  },
  {
    path: '/relatorios/impressao-de-cartao',
    exact: true,
    component: ProposalsCardPrinting,
  },
  {
    path: '/relatorios/termo-de-responsabilidade-entrega-cartao',
    exact: true,
    component: DeliveryTerm,
  },
  {
    path: '/relatorios/propostas-por-organizacao',
    exact: true,
    component: ProposalsByOrganization,
  },
  {
    path: '/relatorios/propostas-por-plano',
    exact: true,
    component: ProposalsByPlan,
  },
  {
    path: '/relatorios/rede-credenciada',
    exact: true,
    component: ProposalsByCredentialsNT,
  },
  {
    path: '/relatorios/financeiro-desconto-folha',
    exact: true,
    component: FinancialPayrollDiscount,
  },
  {
    path: '/relatorios/financeiro/contas-a-receber',
    exact: true,
    component: FinancialBillsToReceive,
  },
  {
    path: '/relatorios/financeiro/contas-a-pagar',
    exact: true,
    component: FinancialBillsToPay,
  },
  {
    path: '/relatorios/comissao-corretores',
    exact: true,
    component: SellersCommission,
  },
  {
    path: '/relatorios/impressao-de-envelope',
    exact: true,
    component: EnvelopePrint,
  },
];
